/* eslint-disable @atlaskit/design-system/no-styled-tagged-template-expression */
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage/preview */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from 'styled-components';

import { type Size } from '@atlaskit/icon';
import { token } from '@atlaskit/tokens';

export interface PoweredByAtlasStyleProps {
	size: Size;
}

interface IconStyles {
	columnGap: number;
	font_Size: number;
}

type StyleMap = { [size in Size]: IconStyles };

export const STYLE_FOR_SIZE: StyleMap = {
	// 48px icon
	xlarge: {
		columnGap: 12,
		font_Size: 36,
	},

	// 32px icon
	large: {
		columnGap: 8,
		font_Size: 24,
	},

	// 24px icon
	medium: {
		columnGap: 6,
		font_Size: 18,
	},

	// 16px icon
	small: {
		columnGap: 4,
		font_Size: 12,
	},
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const PoweredByAtlasContainer = styled.a<PoweredByAtlasStyleProps>`
	color: inherit;
	text-decoration: none;
	display: flex;
	flex-direction: row;
	flex-wrap: nowrap;
	column-gap: ${({ size }) => STYLE_FOR_SIZE[size].columnGap}px;
	align-items: center;

	margin-top: ${token('space.150', '12px')};
`;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const PoweredByAtlasText = styled.span<PoweredByAtlasStyleProps>`
	font-size: ${({ size }) => STYLE_FOR_SIZE[size].font_Size}px;
	color: ${token('color.text.subtlest', '#626F86')};
	&:hover {
		color: ${token('color.text.subtle', '#44546F')};
	}
`;
